import {Pipe, PipeTransform} from '@angular/core';
import {PermissionsService} from '../service/permissions.service';

@Pipe({
    name: 'hasPermissions',
    pure: false,
    standalone: true
})
export class NlrHasPermissionsPipe implements PipeTransform {
    constructor(private permissionsService: PermissionsService) {}

    transform(names: string[]): boolean {
        return this.permissionsService.hasPermission(names);
    }
}
